<template>
<Layout>
  <div class="section content">
    <h1 class="is-size-5">Imprint</h1>
    <span class="is-size-7">
      <p>
        778mobile GmbH<br>
        HRB 79227 // USt-IdNr: DE303966009<br>
        Mei Li-BERLIT, manager director<br>
         Wiesenstraße 21a2<br>
        DE-40549 Düsseldorf - Germany<br>
        E-Mail: <a href="mailto:ie.mg.cuca@778mobile.com">ie.mg.cuca@778mobile.com</a> <br>
        Helpline: <a href="tel:+35315566568">15566568</a>
      </p>
    </span>
  </div>
</Layout>
</template>

<script>
import Layout from '@/layouts/Kyf'

export default {
  name: 'Imprint',
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangKyf/IE/Imprint.vue